/**
 * @summary categories constants
 * @author Dominik Haas-Artho
 *
 * Created at     : 2019-10-23 16:34:51
 * Last modified  : 2019-10-23 16:46:09
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const FOREST = 'forest';
export const SNOW = 'snow';
export const LAND = 'land';
export const HAZARD = 'hazard';
export const DIVERSITY = 'diversity';
export const CLIMATE = 'climate';
